var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { attrs: { id: "subheader" } }),
    _vm._v(" "),
    _c("div", { attrs: { id: "main-container" } }, [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { attrs: { id: "container" } }, [
        _c("div", { attrs: { id: "list-header-container" } }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.filter,
                expression: "filter"
              }
            ],
            attrs: {
              id: "busqueda",
              type: "text",
              placeholder: "Busqueda de clientes por nombre o código"
            },
            domProps: { value: _vm.filter },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.filter = $event.target.value
              }
            }
          })
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticStyle: { "margin-top": "40dp" },
            attrs: { id: "list-container" }
          },
          [
            _vm.filtered.length
              ? _c(
                  "table",
                  { attrs: { cellspacing: "20" } },
                  _vm._l(_vm.filtered, function(item, key) {
                    return _c("tr", { key: key }, [
                      _c("td", [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.empresa,
                              expression: "empresa"
                            }
                          ],
                          attrs: { type: "radio", id: "empresa-" + item.Id },
                          domProps: {
                            value: item,
                            checked: _vm._q(_vm.empresa, item)
                          },
                          on: {
                            change: function($event) {
                              _vm.empresa = item
                            }
                          }
                        })
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c("label", { attrs: { for: "empresa-" + item.Id } }, [
                          _vm._v(_vm._s(item.EmpresaNombre))
                        ])
                      ])
                    ])
                  })
                )
              : _c("div", [
                  _vm._v(
                    "\n          No se encontraron resultados...\n        "
                  )
                ])
          ]
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticStyle: { "text-align": "center", "margin-top": "30px" } },
        [
          _c("button", { attrs: { id: "btnok" }, on: { click: _vm.next } }, [
            _vm._v("CONTINUAR")
          ])
        ]
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { attrs: { id: "label-container" } }, [
      _c("span", { attrs: { id: "label" } }, [_vm._v("Empresas")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1a805e85", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1a805e85","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/preselect/empresas.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-1a805e85","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/preselect/empresas.vue
// module chunks = 0